export function tehranTodayYMD(date: Date = new Date()): string {
  // en-CA produces YYYY-MM-DD reliably
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tehran',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  return fmt.format(date);
}

export function formatTehranDate(value: Date | string | number, locale: string = 'fa-IR'): string {
  const d = value instanceof Date ? value : new Date(value);
  return d.toLocaleDateString(locale, { timeZone: 'Asia/Tehran' });
}

export function formatTehranDateTime(value: Date | string | number, locale: string = 'fa-IR'): string {
  const d = value instanceof Date ? value : new Date(value);
  return d.toLocaleString(locale, { timeZone: 'Asia/Tehran' });
}
